import Client from 'clients/ast'
import { Layout } from 'layouts/ast/index'
import * as Context from 'layouts/ast/context'
import { Courses as Form } from 'layouts/ast/forms'
import { Courses as Table } from 'layouts/ast/tables'
import * as Params from '@avcan/utils/params'

export async function getStaticProps() {
    return {
        props: {
            courses: await Client.getCourses(),
        },
        revalidate: 300, // in seconds, 5 minutes
    }
}

export default function Courses({ courses }) {
    return (
        <Context.Provider paramsSchema={ParamsSchema}>
            <Layout form={<Form />} table={<Table data={courses} />} />
        </Context.Provider>
    )
}

// Constants
const ParamsSchema = {
    level: Params.StringParam,
    from: Params.DateParam,
    to: Params.DateParam,
    tags: Params.SetParam,
    sorting: Params.SortingParam,
    place: Params.StringParam,
    longitude: Params.NumberParam,
    latitude: Params.NumberParam,
}
